export default __webpack_public_path__ + "static/media/midasi_point_th_pc.357cd7ec.png";